// import { struct } from 'superstruct'
import { struct } from '../lib/vendor/superstruct-0.5.0'

export default struct({
  ref: 'string',
  coin: 'string',
  amount: 'number'
})
